import React, { useState } from 'react';
import { Group } from '../../../../../graphql/graphql';
import styles from './EArchiveGroupListItem.module.scss';
import useTranslation from '../../../../../Hooks/useTranslation';
import EArchiveGroupListItemDeleteButton from './EArchiveGroupListItemDeleteButton';
import { useGroupsContext } from '../../../Services/GroupsContext';
import { GroupListContent } from '../../../Enums/GroupListContent.enum';
import EArchiveGroupModal from '../../EArchiveGroup/EArchiveGroupModal';
import { GroupDetailListContent } from '../../../Enums/GroupDetailListContent.enum';

interface Props {
	group: Group;
	refetchGroups: () => void;
}

const EArchiveGroupListItem = ({ group, refetchGroups }: Props) => {
	const [isGroupDetailOpen, setIsGroupDetailOpen] = useState(false);
	const { t } = useTranslation();
	const { groupListContent, setGroupListContent, setGroupDetailListContent } =
		useGroupsContext();

	const initial = group.name?.trim()?.charAt(0).toUpperCase();
	const memberCount = group.totalMembers ?? 0;

	const onDelete = () => {
		setIsGroupDetailOpen(false);
		setGroupListContent(GroupListContent.GROUPS);
		refetchGroups();
	};

	const onCloseGroupDetailModal = () => {
		setIsGroupDetailOpen(false);
		setGroupDetailListContent(GroupDetailListContent.MEMBERS);
		refetchGroups();
	};

	return (
		<>
			<div className={styles.item} onClick={() => setIsGroupDetailOpen(true)}>
				{groupListContent === GroupListContent.GROUPS_DELETE && (
					<EArchiveGroupListItemDeleteButton
						group={group}
						onSubmit={onDelete}
					/>
				)}
				{initial && <div className={styles.avatar}>{initial}</div>}
				{group.name && <div className={styles.name}>{group.name}</div>}
				<div className={styles.info}>
					{t('component.eArchive.groups.memberCount')}
					{memberCount}
				</div>
			</div>
			{isGroupDetailOpen && (
				<EArchiveGroupModal
					groupId={group.id}
					isSystemGroup={group.system ?? false}
					groupType={group.type ?? undefined}
					onDelete={onDelete}
					onClose={onCloseGroupDetailModal}
				/>
			)}
		</>
	);
};

export default EArchiveGroupListItem;
